import type { CsvRow } from '../csv/downloadCsv';
import type { AdvancedRiskRule } from 'src/admin/models/LabRiskSettingsModel';

export interface AdvancedRulesCsvValueLabels {
    enabled: string;
    disabled: string;
}

export interface AdvancedRulesCsvColumnLabels {
    id: string;
    firm: string;
    memberFirm: string;
    account: string;
    route: string;
    provider: string;
    symbol: string;
    maxPrice: string;
    maxSize: string;
    maxOrderTotal: string;
    maxDailySize: string;
    enabled: string;
}

/**
 * Serialize the advanced rules to CSV row objects mirroring the table's
 * columns. Pure: the caller supplies the localized header labels.
 * Unconstrained scope columns export as blank cells like the UI's N/A
 * placeholders.
 */
export function buildAdvancedRulesCsvRows(
    rules: ReadonlyArray<AdvancedRiskRule>,
    columnLabels: AdvancedRulesCsvColumnLabels,
    valueLabels: AdvancedRulesCsvValueLabels,
): CsvRow[] {
    return rules.map((rule) => ({
        [columnLabels.id]: rule.id,
        [columnLabels.firm]: rule.firm,
        [columnLabels.memberFirm]: rule.memberFirm ?? '',
        [columnLabels.account]: rule.account ?? '',
        [columnLabels.route]: rule.route ?? '',
        [columnLabels.provider]: rule.provider ?? '',
        [columnLabels.symbol]: rule.symbol ?? '',
        [columnLabels.maxPrice]: rule.maxPrice ?? '',
        [columnLabels.maxSize]: rule.maxSize ?? '',
        [columnLabels.maxOrderTotal]: rule.maxOrderTotal ?? '',
        [columnLabels.maxDailySize]: rule.maxDailySize ?? '',
        [columnLabels.enabled]: rule.enabled ? valueLabels.enabled : valueLabels.disabled,
    }));
}
